import React from "react";
import styled from "styled-components";

import { MdClose } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { useSideBarContext } from "../context/sidebar_context";
import { useCoursesContext } from "../context/courses_context";
import { useAuth0 } from "@auth0/auth0-react";

const Sidebar = () => {
  const { categories } = useCoursesContext();
  const { closeSidebar, isSidebarOpen } = useSideBarContext();
  const { user, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();
  return (
    <SidebarWrapper
      className={`bg-white ${isSidebarOpen ? "show-sidebar" : ""}`}
    >
      <button
        type="button"
        className="sidebar-close-btn"
        onClick={() => closeSidebar()}
      >
        <MdClose />
      </button>
      <div className="sidebar-content">
        <h6 className="fs-18">Top Categories</h6>
        <ul className="sidebar-category">
          {
            // categories here
            categories.map((category, index) => {
              return (
                <li className="sidebar-link-item fw-5" key={index}>
                  <Link to={`category/${category}`}>
                    {category.toUpperCase()}
                  </Link>
                </li>
              );
            })
          }
        </ul>

        {isAuthenticated && user && user["email"].includes("student") && (
          <h3
            onClick={() => {
              return navigate("/recommendation");
            }}
            style={{
              padding: "0.5em",
              border: "1px dashed #000",
              width: "fit-content",
              marginBottom: "1em",
              background: "#F5F5CF",
              cursor: "pointer",
              marginLeft: "1.5em",
              marginTop: "1em",
            }}
          >
            Recommend
          </h3>
        )}
        {isAuthenticated && user && user["email"].includes("faculty") && (
          <h3
            onClick={() => {
              return navigate("/feedback");
            }}
            style={{
              padding: "0.5em",
              border: "1px dashed #000",
              width: "fit-content",
              marginBottom: "1em",
              background: "#F5F5CF",
              cursor: "pointer",
            }}
          >
            Feedback Form
          </h3>
        )}
      </div>
    </SidebarWrapper>
  );
};

const SidebarWrapper = styled.div`
  position:fixed;
  top:0;
  right:0;
  width:300px;
  z-index:10;
  height:100%;
  padding:30px;
  box-shadow:rgba(0,0,0, .15) 0px 3px 8px;
  transform translateX(100%);
  transition:var(--transition);

  &.show-sidebar{
    transform:translateX(0)
  }
  .sidebar-close-btn{
    position:absolute;
    right:20px;
    top:20px;
    border:2px solid var(--clr-black);
    display:flex;
    align-items:center;
    justify-content:center;
    width:26px;
    height:26px;
    border-radius:50%;
    transition: all 300ms ease-in-out;
  }
  .sidebar-close-btn:hover{
    background:var(--clr-black);
    color:var(--clr-white);
  }
  .sidebar-content{
    margin-top:50px;
    h6{
      margin-bottom:16px;
    }
    .sidebar-link-item{
      font-size:15px;
      margin-bottom:12px;
      transition:var(--transition);

      &:hover{
        transform:translateX(6px);
        text-decoration:underline;
      }
    }
  }
`;

export default Sidebar;
